export const FETCH_LEAVES = "FETCH_LEAVES";
export function fetchLeaves(payload) {
  return {
    type: FETCH_LEAVES,
    payload
  };
}

export const SET_TRANSFER_WARNING = "SET_TRANSFER_WARNING";
export function setWarningWhileTransfer(payload) {
  return {
    type: SET_TRANSFER_WARNING,
    payload
  };
}

export const VALIDATE_TRANSFER = "VALIDATE_TRANSFER";
export function validateTransferTasks(payload) {
  return {
    type: VALIDATE_TRANSFER,
    payload
  };
}

export const SHOW_TRANSFER_WARNINGS = "SHOW_TRANSFER_WARNINGS";
export function showTransferWarnings(payload) {
  return {
    type: SHOW_TRANSFER_WARNINGS,
    payload
  };
}

export const FETCH_PENDING_TASKS_SELECTED_RMBUDDY =
  "FETCH_PENDING_TASKS_SELECTED_RMBUDDY";
export function fetchPendingTasksOfSelectedRMBuddy(payload) {
  return { type: FETCH_PENDING_TASKS_SELECTED_RMBUDDY, payload };
}

export const SET_PENDING_TASKS_SELECTED_RMBUDDY =
  "SET_PENDING_TASKS_SELECTED_RMBUDDY";
export function setPendingTasksOfSelectedRMBuddy(payload) {
  return { type: SET_PENDING_TASKS_SELECTED_RMBUDDY, payload };
}

export const APPLY_LEAVES = "APPLY_LEAVES";
export function applyLeaves(payload) {
  return {
    type: APPLY_LEAVES,
    payload
  };
}

export const REMOVE_LEAVES = "REMOVE_LEAVES";
export function removeLeaves(payload) {
  return {
    type: REMOVE_LEAVES,
    payload
  };
}

export const SET_LEAVES = "SET_LEAVES";
export function setSelectedRmBuddyLeaves(payload) {
  return {
    type: SET_LEAVES,
    payload
  };
}

export const SEARCH_BY_ORDER_NUMBER_OR_SERVICE_REQ_ID =
  "SEARCH_BY_ORDER_NUMBER_OR_SERVICE_REQ_ID";
export function searchTasksByOrderNumberOrServiceReqId(payload) {
  return {
    type: SEARCH_BY_ORDER_NUMBER_OR_SERVICE_REQ_ID,
    payload
  };
}

export const SET_SEARCH_TASK_RESULTS = "SET_SEARCH_TASK_RESULTS";
export function setSearchTaskResults(payload) {
  return {
    type: SET_SEARCH_TASK_RESULTS,
    payload
  };
}

export const SET_RM_BUDDY_TASKS = "SET_RM_BUDDY_TASKS";
export function setRmBuddyTasks(payload) {
  return {
    type: SET_RM_BUDDY_TASKS,
    payload
  };
}

export const SET_SELECTED_RM_BUDDY = "SET_SELECTED_RM_BUDDY";
export function setSelectedRmBuddyId(payload) {
  return {
    type: SET_SELECTED_RM_BUDDY,
    payload
  };
}

export const TRANSFER_RM_BUDDY_TASK = "TRANSFER_RM_BUDDY_TASK";
export function transferRmBuddyTask(payload) {
  return {
    type: TRANSFER_RM_BUDDY_TASK,
    payload
  };
}

export const FETCH_SUGGESTED_TRANSFER_BUDDIES =
  "FETCH_SUGGESTED_TRANSFER_BUDDIES";
export function fetchSuggestedTransferBuddies(payload) {
  return {
    type: FETCH_SUGGESTED_TRANSFER_BUDDIES,
    payload
  };
}

export const SET_SUGGESTED_TRANSFER_BUDDIES = "SET_SUGGESTED_TRANSFER_BUDDIES";
export function setSuggestedTransferBuddies(payload) {
  return {
    type: SET_SUGGESTED_TRANSFER_BUDDIES,
    payload
  };
}

export const MARK_RM_BUDDY_TASK_DONE = "MARK_RM_BUDDY_TASK_DONE";
export function markRmBuddyTaskAsDone(payload) {
  return {
    type: MARK_RM_BUDDY_TASK_DONE,
    payload
  };
}

export const FETCH_RM_BUDDY_TASK_DETAIL = "FETCH_RM_BUDDY_TASK_DETAIL";
export function fetchTaskDetails(payload) {
  return {
    type: FETCH_RM_BUDDY_TASK_DETAIL,
    payload
  };
}

export const SET_RM_BUDDY_TASK = "SET_RM_BUDDY_TASK";
export function setRmBuddyTaskDetail(payload) {
  return {
    type: SET_RM_BUDDY_TASK,
    payload
  };
}

export const SET_UNALLOCATED_RM_BUDDY_TASKS = "SET_UNALLOCATED_RM_BUDDY_TASKS";
export function setUnallocatedRmBuddyTasks(payload) {
  return {
    type: SET_UNALLOCATED_RM_BUDDY_TASKS,
    payload
  };
}

export const SET_DELAYED_RM_BUDDY_TASKS = "SET_DELAYED_RM_BUDDY_TASKS";
export function setDelayedRmBuddyTasks(payload) {
  return {
    type: SET_DELAYED_RM_BUDDY_TASKS,
    payload
  };
}

export const SET_TASKS_DUE_DATE_FILTER = "SET_TASKS_DUE_DATE_FILTER";
export function setTasksDueDateFilter(payload) {
  return {
    type: SET_TASKS_DUE_DATE_FILTER,
    payload
  };
}

export const SET_TASKS_TYPE_FILTER = "SET_TASKS_TYPE_FILTER";
export function setTasksTypeFilter(payload) {
  return {
    type: SET_TASKS_TYPE_FILTER,
    payload
  };
}

export const SET_TASKS_STATUS_TAG_FILTER = "SET_TASKS_STATUS_TAG_FILTER";
export function setTasksStatusTagFilter(payload) {
  return {
    type: SET_TASKS_STATUS_TAG_FILTER,
    payload
  };
}

export const SET_RM_BUDDIES = "SET_RM_BUDDIES";
export function setRmBuddiesList(payload) {
  return {
    type: SET_RM_BUDDIES,
    payload
  };
}

export const SET_BUDDY_BLOCKS_LIST = "SET_BUDDY_BLOCKS_LIST";
export function setBuddyBlocksList(payload) {
  return {
    type: SET_BUDDY_BLOCKS_LIST,
    payload
  };
}

export const FETCH_RM_BUDDIES_WAREHOUSE_LIST =
  "FETCH_RM_BUDDIES_WAREHOUSE_LIST";
export function fetchRmBuddiesWarehouseList() {
  return {
    type: FETCH_RM_BUDDIES_WAREHOUSE_LIST
  };
}

export const SET_RM_BUDDIES_WAREHOUSE_LIST = "SET_RM_BUDDIES_WAREHOUSE_LIST";
export function setRmBuddiesWarehouseList(payload) {
  return {
    type: SET_RM_BUDDIES_WAREHOUSE_LIST,
    payload
  };
}

export const SET_RM_BUDDIES_WAREHOUSE_ID = "SET_RM_BUDDIES_WAREHOUSE_ID";
export function setCurrentRmBuddiesWarehouseId(payload) {
  return {
    type: SET_RM_BUDDIES_WAREHOUSE_ID,
    payload
  };
}

export const SET_RM_BUDDIES_SEARCH_QUERY = "SET_RM_BUDDIES_SEARCH_QUERY";
export function setRmBuddiesSearchQueryFilter(payload) {
  return {
    type: SET_RM_BUDDIES_SEARCH_QUERY,
    payload
  };
}

export const SET_RM_BUDDIES_SERVER_SEARCH_QUERY =
  "SET_RM_BUDDIES_SERVER_SEARCH_QUERY";
export function setRmBuddiesServerSearchQuery(payload) {
  return {
    type: SET_RM_BUDDIES_SERVER_SEARCH_QUERY,
    payload
  };
}

export const SET_VISIBLE_RM_BUDDIES = "SET_VISIBLE_RM_BUDDIES";
export function setVisibleRmBuddiesList(payload) {
  return {
    type: SET_VISIBLE_RM_BUDDIES,
    payload
  };
}

export const SET_RM_BUDDIES_SEARCH_RESULTS = "SET_RM_BUDDIES_SEARCH_RESULTS";
export function setRmBuddiesSearchResults(payload) {
  return {
    type: SET_RM_BUDDIES_SEARCH_RESULTS,
    payload
  };
}

// TODO: refactor into common actions
export const ASSIGN_RM_BUDDY = "ASSIGN_RM_BUDDY";
export function assignRmBuddyToBuddyBlock(payload) {
  return {
    type: ASSIGN_RM_BUDDY,
    payload
  };
}

export const SET_RM_BUDDIES_FILTER_BUDDY_BLOCK =
  "SET_RM_BUDDIES_FILTER_BUDDY_BLOCK";
export function setRmBuddiesFilterBuddyBlockId(payload) {
  return {
    type: SET_RM_BUDDIES_FILTER_BUDDY_BLOCK,
    payload
  };
}

export const UPLOAD_RM_BUDDIES = "UPLOAD_RM_BUDDIES";
export function uploadRmBuddiesExcel(payload) {
  return {
    type: UPLOAD_RM_BUDDIES,
    payload
  };
}

export const SET_UPLOAD_RM_BUDDIES_STATUS = "SET_UPLOAD_RM_BUDDIES_STATUS";
export function setUploadRmBuddiesStatus(payload) {
  return {
    type: SET_UPLOAD_RM_BUDDIES_STATUS,
    payload
  };
}

export const UPDATE_PROFILE_SELECTED_BUDDY = "UPDATE_PROFILE_SELECTED_BUDDY";
export function updateProfileSelectedBuddy(payload) {
  return {
    type: UPDATE_PROFILE_SELECTED_BUDDY,
    payload
  };
}

export const SET_UPDATED_PROFILE_SELECTED_BUDDY =
  "SET_UPDATED_PROFILE_SELECTED_BUDDY";
export function setUpdatedProfileSelectedBuddy(payload) {
  return {
    type: SET_UPDATED_PROFILE_SELECTED_BUDDY,
    payload
  };
}
